<!-- pb-24 while the callout shows: it is fixed to the viewport, so without room at the
     end of the document it covers whatever the last screen happens to hold.
     scripts/ui-audit.mjs fails on a control sitting under another one, which is how the
     first version of this was caught. -->
<div
  class="layout-container flex min-h-screen flex-col overflow-x-clip bg-surface text-fg"
  [class.pb-24]="showCallout && !calloutDismissed()"
>
  @if (environmentLabel) {
    <!-- Above the accent bar and the header, so it is the first thing on the page and
         cannot be mistaken for part of the app's own chrome. -->
    <div
      class="w-full shrink-0 bg-warning/15 px-4 py-1.5 text-center text-sm font-medium text-warning-fg"
    >
      {{ environmentLabel }}
    </div>
  }
  <!-- An accent rectangle across the top of the whole layout (Refactoring UI, "Add color
       with accent borders"). Two hues under 30 degrees apart, which is the book's rule
       for a gradient that reads energetic instead of muddy. -->
  <div
    class="h-1 w-full shrink-0 bg-gradient-to-r from-brand via-brand-hover to-success"
  ></div>
  <!-- No border under the header: it is already a lighter surface than the page, and a
       rule on top of that reads as a seam. Same for the footer. -->
  <header class="bg-surface-card">
    <div
      class="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4 sm:px-6 lg:px-8"
    >
      <!-- A wordmark, not the round logo. appLogo.png sets the club name in a ring around
           the bike, which is illegible below about 120px, so at 40px it read as a smudge.
           Refactoring UI's rule for an asset used far under its intended size is to draw
           the simplified version rather than let the browser shrink it: the bike glyph
           carries the mark and the name is set as text, which stays sharp at any size. -->
      <a
        routerLink="/start"
        class="flex min-h-11 min-w-11 shrink-0 items-center gap-2.5"
        aria-label="Spinning Heracles Westerlo"
      >
        <svg
          viewBox="0 0 300.25 300.25"
          class="size-8 shrink-0 text-brand"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            d="M238.703,127.946c-5.119,0-10.089,0.487-14.847,1.67l-18.955-50.955h6.176c9.72,0,18.913-3.577,25.887-10.345l6.541-6.273	c2.973-2.885,3.043-7.595,0.158-10.568s-7.633-3.024-10.605-0.139l-6.541,6.206c-4.159,4.037-9.643,6.118-15.439,6.118h-16.979	c-2.458,0-4.76,1.356-6.161,3.375c-1.401,2.02-1.725,4.673-0.865,6.975l7.214,19.372c-0.046-0.001-0.093,0.141-0.139,0.141	c-0.016,0-0.032,0.137-0.049,0.137H98.126L85.165,71.823l14.078-4.895c3.467-1.191,5.564-4.55,4.961-8.166	c-0.604-3.615-3.731-6.101-7.397-6.101H55.597c-5.775,0-10.475,4.506-10.475,10.281c0,8.941,7.266,16.12,16.196,16.12	c1.79,0,3.565-0.347,5.277-0.934l4.103-1.433l13.146,21.996l-10.097,30.285c-3.312-0.669-6.714-1.09-10.193-1.201	c-17.589-0.563-34.055,6.138-46.219,18.697c-11.694,12.074-17.84,27.992-17.303,44.822c1.032,32.337,27.172,58.476,59.509,59.508	c0.673,0.021,1.34,0.032,2.008,0.032c16.811,0,32.513-6.716,44.212-18.794c9.464-9.773,15.291-22.38,16.885-35.38h12.051	c2.598,2,5.961,3.634,9.639,3.634c8.196,0,14.864-6.636,14.864-14.833c0-2.661-0.712-5.139-1.942-7.303l42.042-71.305l10.553,28.289	c-19.435,10.359-32.698,30.831-32.698,54.348c0,33.938,27.61,61.549,61.548,61.549s61.547-27.61,61.547-61.547	S272.641,127.946,238.703,127.946z M180.979,108.661l-36.606,62.091c-0.013,0-0.025-0.062-0.037-0.062	c-0.043,0-0.084,0.096-0.127,0.097l-37.131-62.125H180.979z M93.992,115.669l37.378,62.514c-0.618,1.101-1.089,2.478-1.412,3.478	h-7.326c-2.591-21-16.064-39.121-34.658-48.001L93.992,115.669z M74.447,181.661c-0.503-1-1.081-1.526-1.728-2.233l8.865-26.626	c10.72,5.925,18.562,16.859,20.834,28.859H74.447z M91.395,218.126c-8.215,8.481-19.311,13.04-31.215,12.655	c-21.822-0.696-39.461-18.319-40.157-40.141c-0.363-11.369,3.784-22.112,11.679-30.262c7.898-8.154,18.497-12.642,29.845-12.642	c0.455,0,0.91,0.01,1.369,0.024c1.502,0.048,2.981,0.185,4.439,0.389l-8.966,26.9c-6.569,1.537-11.481,7.43-11.481,14.461	c0,8.196,6.668,14.801,14.863,14.801c5.552,0,10.395-2.65,12.947-7.65h27.699C100.966,204.661,97.197,212.135,91.395,218.126z M238.703,231.042c-22.909,0-41.548-18.639-41.548-41.548c0-14.932,7.921-28.044,19.779-35.369l14.098,37.785	c1.125,3.017,3.986,4.88,7.027,4.88c0.871,0,1.757-0.152,2.621-0.476c3.881-1.447,5.853-5.768,4.404-9.648l-14.169-37.977	c2.524-0.481,5.125-0.743,7.788-0.743c22.909,0,41.547,18.639,41.547,41.548S261.613,231.042,238.703,231.042z"
          />
        </svg>
        <span class="hidden leading-tight sm:block">
          <span class="block text-sm font-bold text-fg">Spinning Heracles</span>
          <span class="block text-xs font-medium text-fg-subtle">Westerlo</span>
        </span>
      </a>

      <!-- Places on the left, actions on the right. All ten entries in one row measured
           1296px, which a 1280 laptop does not have, so the four club-management tools
           fold into one menu and Inloggen/Aanmelden move to the action cluster where a
           member sees Uitloggen. That leaves at most six links in the bar.
           scripts/ui-audit.mjs fails on overlapping controls, so a regression here is
           caught rather than eyeballed. -->
      <nav class="ml-6 hidden min-w-0 items-center gap-0.5 xl:flex">
        @for (item of mainNav(); track item.link) {
          <a
            [routerLink]="item.link"
            routerLinkActive="border-brand bg-surface-raised text-brand"
            class="flex items-center gap-1.5 whitespace-nowrap rounded-md border-b-2 border-transparent px-3 py-2 text-sm font-medium text-fg-muted hover:bg-surface-raised hover:text-fg"
          >
            <app-icon [name]="item.icon" size="size-4" />
            {{ item.label }}
          </a>
        }

        @if (adminNav().length) {
          <!-- Native <details>: a disclosure with keyboard and Escape behaviour built in,
               and no click-outside handler to get wrong. Closed on navigation. -->
          <details #adminMenu class="relative">
            <summary
              class="flex cursor-pointer list-none items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-fg-muted marker:content-none hover:bg-surface-raised hover:text-fg"
            >
              <app-icon name="users" size="size-4" />
              Beheer
              <app-icon name="chevron-down" size="size-3" />
            </summary>
            <div
              class="absolute right-0 z-20 mt-1 w-56 overflow-hidden rounded-card bg-surface-raised py-1 shadow-lg"
            >
              @for (item of adminNav(); track item.link) {
                <a
                  [routerLink]="item.link"
                  routerLinkActive="text-brand"
                  class="flex items-center gap-2 px-3 py-2.5 text-sm font-medium text-fg-muted hover:bg-surface-card hover:text-fg"
                >
                  <app-icon [name]="item.icon" size="size-4" />
                  {{ item.label }}
                </a>
              }
            </div>
          </details>
        }
      </nav>

      <!-- Inloggen / Aanmelden are actions, not places, so they sit in the right-hand
           cluster instead of running on from "Start  Info" with the same weight. -->
      @if (authNav().length) {
        <div class="ml-auto hidden items-center gap-2 xl:flex">
          @for (item of authNav(); track item.link) {
            <a
              appButton
              [variant]="item.link === '/aanmelden' ? 'primary' : 'secondary'"
              size="sm"
              [routerLink]="item.link"
            >
              {{ item.label }}
            </a>
          }
        </div>
      }

      @if (user$ | async; as user) {
        <div class="ml-auto flex items-center gap-2">
          <!-- Avatar disc plus the first name, the Tailwind Plus navbar pattern. The
               disc shows at every width and carries the brand colour where identity
               belongs; the name joins it from lg, where there is room. The old version
               was a 140px truncating pill that only appeared above 1536. -->
          <span
            class="flex shrink-0 items-center gap-2"
            [title]="user.displayName || user.firstName"
            [attr.aria-label]="
              'Aangemeld als ' + (user.displayName || user.firstName)
            "
          >
            <span
              class="grid size-9 place-items-center rounded-full bg-brand/15 text-sm font-semibold text-brand"
              aria-hidden="true"
            >
              {{ initials(user) }}
            </span>
            <span class="hidden text-sm font-medium text-fg lg:block">
              {{ user.firstName | titlecase }}
            </span>
          </span>
          <!-- min-w-11: below sm: the label is hidden and only the icon remains, which
               leaves the button narrower than it is tall. The aria-label carries the
               name at those widths, where the icon is the only content and it is
               aria-hidden: on a phone this sits next to the menu button, and an
               unnamed control there is a log-out nobody saw coming. -->
          <button
            appButton
            variant="secondary"
            size="sm"
            class="min-w-11"
            aria-label="Uitloggen"
            (click)="logout()"
          >
            <app-icon name="power" size="size-4" />
            <span class="hidden sm:inline">Uitloggen</span>
          </button>
        </div>
      }

      <!-- Mobile menu button -->
      <button
        type="button"
        class="rounded-md p-3 text-fg-muted hover:bg-surface-raised hover:text-fg xl:hidden"
        [attr.aria-expanded]="menuOpen()"
        aria-label="Menu"
        (click)="toggleMenu()"
      >
        <app-icon [name]="menuOpen() ? 'x' : 'bars'" size="size-6" />
      </button>
    </div>

    <!-- Mobile navigation: same nav() array, so a link cannot exist on one and not the other -->
    @if (menuOpen()) {
      <nav class="border-t border-border/60 px-4 py-3 xl:hidden">
        @for (item of nav(); track item.link) {
          <a
            [routerLink]="item.link"
            routerLinkActive="border-brand bg-surface-raised text-brand"
            class="flex items-center gap-3 rounded-md border-l-2 border-transparent px-3 py-2.5 text-base font-medium text-fg-muted hover:bg-surface-raised hover:text-fg"
          >
            <app-icon [name]="item.icon" size="size-5" />
            {{ item.label }}
          </a>
        }
      </nav>
    }
  </header>

  @if (showCallout && !calloutDismissed()) {
    <!-- Tailwind Plus, marketing > elements > banners, "floating at bottom": out of the
         way while someone explores, still there when they have seen enough. The page
         gets bottom padding below so it can never cover the footer. -->
    <div
      data-floating="dismissible"
      class="pointer-events-none fixed inset-x-0 bottom-0 z-30 sm:px-6 sm:pb-5 lg:px-8"
    >
      <div
        class="pointer-events-auto mx-auto flex max-w-3xl items-center justify-between gap-x-4 bg-surface-card px-4 py-2.5 inset-ring inset-ring-border sm:rounded-card sm:py-3 sm:pr-3.5 sm:pl-4"
      >
        <p class="text-sm/6 text-fg-muted">
          <a
            [href]="portfolioUrl"
            target="_blank"
            rel="noopener"
            class="inline-block py-1 hover:text-fg"
          >
            <!-- &ngsp; and not a plain newline: the formatter puts the closing bracket
                 on its own line, which swallows the whitespace and glued the question to
                 the link. A non-breaking space would instead stop the two from wrapping
                 apart on a phone. -->
            <strong class="font-semibold text-fg"
              >Ook een reservatieportaal nodig zoals dit?</strong
            >&ngsp;
            <span class="whitespace-nowrap font-semibold text-brand"
              >wvince.dev <span aria-hidden="true">&rarr;</span></span
            >
          </a>
        </p>
        <button
          type="button"
          class="-m-3 flex-none rounded-md p-3 text-fg-subtle hover:text-fg"
          aria-label="Sluiten"
          (click)="dismissCallout()"
        >
          <app-icon name="x" size="size-5" />
        </button>
      </div>
    </div>
  }

  <!-- A brand wash over the top of the page rather than behind one panel: a gradient that
       stops halfway down reads as an unfinished box. It fades out within the first
       screenful, so the rest of the app keeps the flat surface colour. -->
  <main
    class="flex-1 bg-gradient-to-b from-brand/8 via-surface to-surface bg-no-repeat"
    style="background-size: 100% 420px"
  >
    <div class="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <router-outlet />
    </div>
  </main>

  <footer class="bg-surface-card">
    <!-- Two links on one row, wrapping on a narrow phone. inline-flex + min-h-11 on each:
         as bare inline links these were 20px tap targets. -->
    <div
      class="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 px-4 py-2 text-center sm:px-6 lg:px-8"
    >
      <a
        routerLink="/privacybeleid"
        class="inline-flex min-h-11 items-center px-3 text-sm text-fg-subtle hover:text-fg hover:underline"
      >
        Privacybeleid
      </a>
      <a
        [href]="creditUrl"
        target="_blank"
        rel="noopener"
        class="inline-flex min-h-11 items-center px-3 text-sm text-fg-subtle hover:text-fg hover:underline"
      >
        Gemaakt door wvince.dev
      </a>
    </div>
  </footer>
</div>

<app-toast-outlet />
<app-confirm-outlet />
